function resetElementsAtTop() {
  const navBar = document.querySelector(".top-navigation__container");
  const deliveryWidgetMobile = document.querySelector(".delivery-widget-mobile");
  const masthead = document.querySelector("#masthead");
  const isMobile = window.innerWidth <= 1024;
  
  // Only reset when at the very top (no scroll classes active)
  const isAtTop = !document.body.classList.contains("scrolled") && 
                   !document.body.classList.contains("scrolled-down") && 
                   !document.body.classList.contains("scrolled-up");
  
  if (!isAtTop) {
    return; // Don't reset if scroll classes are active - let CSS handle it
  }
  
  // Reset navigation transform - clear inline styles so CSS classes can control it
  if (navBar) {
    // Clear any GSAP transforms (only transform-related props)
    if (typeof gsap !== "undefined") {
      gsap.set(navBar, { clearProps: "transform,x,y" });
    }
    // Remove inline transform so CSS classes can control it
    navBar.style.transform = "";
    // Remove any inline top positioning that might interfere
    if (isMobile) {
      navBar.style.top = "";
    }
  }
  
  // Reset delivery widget mobile position
  if (deliveryWidgetMobile) {
    // Clear any GSAP transforms
    if (typeof gsap !== "undefined") {
      gsap.set(deliveryWidgetMobile, { clearProps: "transform,x,y" });
    }
    // Ensure it's at top: 0 on mobile, but don't override transform
    deliveryWidgetMobile.style.top = "0";
    deliveryWidgetMobile.style.transform = "";
  }
  
  // Reset masthead position (in case ScrollTrigger affected it on mobile)
  if (masthead && isMobile) {
    // Only clear transform-related props, preserve sticky positioning
    if (typeof gsap !== "undefined") {
      gsap.set(masthead, { clearProps: "transform,x,y" });
    }
    masthead.style.transform = "";
    // Don't clear top on mobile as it needs to stay sticky
  }
}

function initScrollTriggers() {
  const navBar = document.querySelector(".top-navigation__container");
  const navBarHeight = navBar?.offsetHeight || 0;

  // ScrollTrigger for basic scrolled state
  ScrollTrigger.create({
    trigger: "body",
    start: "top -1",
    end: "bottom bottom",
    toggleClass: {
      targets: "body",
      className: "scrolled",
    },
    onUpdate: (self) => {
      // Handle scroll direction
      if (self.direction === 1) {
        // Scrolling down
        if (!document.body.classList.contains("scrolled")) {
          document.body.classList.add("scrolled");
        }

        document.body.classList.add("scrolled-down");
        document.body.classList.remove("scrolled-up");
        
        // Close dropdown menus when scrolling down
        if (window.topNavigation && window.topNavigation.hideAllDropdowns) {
          window.topNavigation.hideAllDropdowns();
        }
      } else if (self.direction === -1) {
        // Scrolling up
        document.body.classList.add("scrolled-up");
        document.body.classList.remove("scrolled-down");
      }

      // Remove all classes when at the very top and reset elements
      if (window.scrollY <= 1) {
        document.body.classList.remove(
          "scrolled-down",
          "scrolled-up",
          "scrolled"
        );
        // Explicitly reset elements when at top
        resetElementsAtTop();
      }
    },
    onToggle: (self) => {
      // When leaving the trigger area (scrolling back to top)
      if (!self.isActive && window.scrollY <= 1) {
        document.body.classList.remove(
          "scrolled-down",
          "scrolled-up",
          "scrolled"
        );
        // Explicitly reset elements when at top
        resetElementsAtTop();
      }
    },
  });
  
  // Additional scroll listener for Android Edge browser quirks
  // This ensures elements reset properly even if ScrollTrigger doesn't fire
  // But only when actually at the top to preserve slide in/out behavior
  let scrollTimeout;
  let lastScrollY = window.scrollY;
  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      // Only reset when actually at the very top
      if (currentScrollY <= 1) {
        resetElementsAtTop();
      }
      lastScrollY = currentScrollY;
    }, 10);
  }, { passive: true });
}

// Initialize ScrollTriggers when DOM is ready
if (document.readyState !== "loading") {
  initScrollTriggers();
  // Ensure elements are reset on initial load
  resetElementsAtTop();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    initScrollTriggers();
    // Ensure elements are reset on initial load
    resetElementsAtTop();
  });
}

// Also reset on page visibility change (handles tab switching on mobile)
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) {
    // Small delay to ensure scroll position is accurate
    setTimeout(() => {
      if (window.scrollY <= 1) {
        resetElementsAtTop();
      }
    }, 50);
  }
});

// Reset on orientation change (common on mobile)
window.addEventListener("orientationchange", () => {
  setTimeout(() => {
    resetElementsAtTop(); // Always reset on orientation change
    if (window.scrollY <= 1) {
      // Double-check after a longer delay
      setTimeout(resetElementsAtTop, 200);
    }
  }, 100);
});

// Additional safeguard: Reset on window load and after images load (Android Edge fix)
window.addEventListener("load", () => {
  setTimeout(() => {
    if (window.scrollY <= 1) {
      resetElementsAtTop();
    }
  }, 100);
});
